<template>
  <div style="background-color: #fff">
    <x-addEdit
        ref="addLeaderEdit"
        formType="modal"
        :isSubmitBtn="false"
        :itemLayout="$store.state.modal_ItemLayout"
        :reqLoading="btnLoading"
        :formList="formLeaderList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
    >
      <template slot="gps" slot-scope="{formItem}">

        <x-location
            ref="location"
            :form="$children[0].form"
            :inputKey="inputKey"
            :position="position"
            :lngLat="lngLat"
            :locationData="formItem">
        </x-location>
      </template>
    </x-addEdit>

  </div>
</template>

<script>
import Common from '@/utils/common';
export default {
  data () {
    return {
      inputKey: {
        lng: 'mapLng',
        lat: 'mapLat',
        address: 'address'
      },
      lngLat: [],
      position: '',
      btnLoading: {loading: false},
      formLeaderList: [
        {
          label: '手机号',
          inputType: 'input',
          options: [],
          placeholder: '请输入手机号',
          props: ['mobilePhone', {
            rules: [
              {required: true, message: '请输入手机号'}
            ]
          }]
        },
        {
          label: '店铺名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入店铺名称',
          props: ['shopName', {
            rules: [
              {required: true, message: '请输入店铺名称'}
            ]
          }]
        },
        {
          label: '主营类目',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择主营类目',
          changeOnSelect: true,
          disabled: false,
          fieldNames: {label: 'label', value: 'value', children: 'children'},
          props: ['categories', {
            rules: [
              {required: true, message: '请选择主营类目'}
            ]
          }]
        },
        {
          label: '所在地区',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择所在地区',
          handle: this.regionChange,
          displayRender: this.regionDisplayRender,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(3, 'formLeaderList', '1,2,3', e);
          },
          props: ['areas', {
            rules: [
              {required: true, message: '请选择所在地区'}
            ]
          }]
        },
        {
          label: '详细地址',
          inputType: 'input',
          options: [],
          placeholder: '请输入详细地址',
          props: ['address', {
            rules: [
              {required: true, message: '请输入详细地址'}
            ]
          }]
        },
        {
          slot: 'gps',
          label: '地图选址',
          inputType: 'input',
          subList: [
            {
              inputType: 'input',
              placeholder: '经度',
              props: ['mapLng', {
                validateTrigger: 'blur',
                rules: [{required: true, message: '请定位经度'}]
              }]
            },
            {
              inputType: 'input',
              placeholder: '纬度',
              props: ['mapLat', {
                validateTrigger: 'blur',
                rules: [{required: true, message: '请定位纬度'}]
              }]
            }
          ]
        },
        // {
        //   label: '经度',
        //   inputType: 'input',
        //   options: [],
        //   placeholder: '请定位经度',
        //   props: ['mapLng', {
        //     rules: [
        //       {required: true, message: '请定位经度'}
        //     ]
        //   }]
        // },
        // {
        //   label: '纬度',
        //   inputType: 'input',
        //   options: [],
        //   placeholder: '请定位纬度',
        //   props: ['mapLat', {
        //     rules: [
        //       {required: true, message: '请定位纬度'}
        //     ]
        //   }]
        // },
        {
          label: '店铺门面',
          inputType: 'upload',
          options: [],
          handle: '',
          placeholder: '',
          extra: '图片大小不超过5MB，最多添加5张，用于店铺展示',
          fileList: [],
          beforeHandle: Common.uploadBeforeHandle,
          uploadParam: {
            url: '/local/upload',
            iconUrl: 'pic',
            limit: 5,
            listType: 'picture',
            accept: this.$store.state.imgAccept,
            uploadType: 1
          },
          props: ['shopImage', {
            rules: [{required: true, message: '请上传店铺门面'}]
          }]
        },
        {
          label: '营业电话',
          inputType: 'input',
          options: [],
          placeholder: '请输入营业电话',
          props: ['telephone', {
            rules: [
              {required: true, message: '请输入营业电话'}
            ]
          }]
        },
        {
          label: '开户行',
          inputType: 'input',
          placeholder: '请输入开户行支行名称',
          props: ['depositBank', {
            rules: [{required: true, message: '请输入开户行支行名称'}]
          }]
        },
        {
          label: '银行账号',
          inputType: 'input',
          placeholder: '请输入银行账号',
          props: ['cardNumber', {
            rules: [{required: true, message: '请输入银行账号'}]
          }]
        },
        {
          label: '账户名称',
          inputType: 'input',
          placeholder: '请输入账户名称',
          props: ['accountName', {
            rules: [{required: true, message: '请输入账户名称'}]
          }]
        }
      ],
      formKey: {
        type: undefined,
        mapLng: undefined,
        mapLat: undefined,
        mobilePhone: undefined,
        shopImage: undefined,
        shopName: undefined,
        categories: undefined,
        areas: undefined,
        address: undefined,
        bizAreaId: undefined,
        telephone: undefined,
        depositBank: undefined,
        cardNumber: undefined,
        accountName: undefined
      },
      addParam: {
        url: '/local/leader/add',
        reqHandle: this.reqHandle,
        resHandle: () => this.addEditResHandle('新增')
      },
      editParam: {
        url: '/local/leader/',
        reqHandle: () => this.editReqHandle(), // this.addReqHandle
        resHandle: () => this.addEditResHandle('编辑')
      },
      detailParam: {
        url: '',
        resHandle: '' // this.detailResHandle
      }
    };
  },
  created () {
    this.regionSelect(3, 'formLeaderList');
    this.getSelect();
  },
  methods: {
    getSelect () {
      // 主营类目下拉
      this.$get({
        url: '/local/leader/categoryTreeSelect'
      }).then(({data}) => {
        this.formLeaderList[2].options = data;
      });
    },

    editReqHandle () {

    },
    // 添加编辑返回处理
    addEditResHandle (msg) {
      this.$message.success(`${msg}成功`);
      this.visible = false;
      this.leaderVisible = false;
      this.$refs.table.getTableList();
    },
    resHandle (res) {
      this.visible = false;
      this.$refs.table.getTableList();
    },
    searchHandle (selectData) {
    },
    reqHandle (param) {
      if (param.areas) {
        param.areas = param.areas.join(',');
      }
      if (param.shopImage) {
        param.shopImage = param.shopImage.join(',');
      }
      if (param.categories) {
        param.categories = param.categories.join(',');
      }
      if (!param.type) {
        param.type = 3;
      }
      return param;
    },
    regionDisplayRender (labels) {
      this.regionChange(undefined, labels);
    },

    regionChange (val, selected) {
      let isArray = Array.isArray(val);
      if (isArray) { // 判断是change事件还是 displayRender
        this.$refs.location && this.$refs.location.positionChanged();
      }
      if (selected && selected.length > 1) {
        let isCity = this.$store.state.citys.some(el => {
          return el === (isArray ? selected[0].label : selected[0]);
        });
        if (isCity) { // 判断是否为直辖市
          this.position = isArray ? selected[0].label : selected[0];
        } else {
          this.position = isArray ? selected[1].label : selected[1];
        }
      }
    },
    recursionList (list) {
      list.forEach(item => {
        item.title = item.label;
        if (item.children && item.children.length) {
          this.recursionList(item.children);
        }
      });
    }
  }
};
</script>

<style>

</style>
